import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { calculatorAPI } from "../../api/calculator/calculator"

const initialState = {
    status: null,
    error: null,
    prices: null,
    usedVolumeWeight: null,
}

export const calculate = createAsyncThunk(
    'calc/calculate',
    async ({data}, {rejectWithValue}) => {
        const response = await calculatorAPI.calculate(data)
        if (response.ok) {
            return response.result
        }
        if (response.err) {
            return rejectWithValue({err: response.err})
        }
        return rejectWithValue({err: 'something_went_wrong'})
    }
)

const calcSlice = createSlice({
    name: 'calc',
    initialState,
    reducers: {
        setCalcStatus(state, action) {
            state.status = action.payload.status ?? null
        },
        setCalcError(state, action) {
            state.error = action.payload.error ?? null
        }
    },
    extraReducers(builder) {
        builder.addCase(calculate.fulfilled, (state, action) => {
            if (!action.payload.prices || action.payload.usedVolumeWeight === undefined) {
                state.status = 'rejected'
                state.error = 'something_went_wrong'
                return
            }

            state.status = 'fulfilled'
            state.error = null
            state.prices = action.payload.prices
            state.usedVolumeWeight = action.payload.usedVolumeWeight
        })
        builder.addCase(calculate.pending, (state, action) => {
            state.status = 'pending'
            state.error = null
        })
        builder.addCase(calculate.rejected, (state, action) => {
            state.status = 'rejected'
            state.error = action.payload.err ?? 'something_went_wrong'
        })
    }
})

export const {
    setCalcStatus,
    setCalcError
} = calcSlice.actions

export const selectCalcStatus = state => state.calc.status
export const selectCalcError = state => state.calc.error
export const selectCalcPrices = state => state.calc.prices
export const selectCalcUsedVolumeWeight = state => state.calc.usedVolumeWeight

export default calcSlice.reducer

